angular.module('unica_media_directory.media_directory_services')

.factory('MediaDirectoryDeleteService', function ($http, getBaseApiURL) {

	var mediaDirectoryDeleteService = {};

	mediaDirectoryDeleteService.delete = function (mediaDirectoryId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/media-directory/delete/' + mediaDirectoryId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return mediaDirectoryDeleteService;
});